var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTopUp = function SvgIconTopUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff",
    fillOpacity: 0.1,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.96 17.24c-.347 0-.7.314-.7.78 0 .353.076.48.114.528.045.057.135.129.375.215l3.013 1.05c.352.126.755.323 1.055.708.308.394.433.885.433 1.449 0 1.228-.95 2.28-2.2 2.28h-1.88c-1.365 0-2.42-1.148-2.42-2.5a.75.75 0 0 1 1.5 0c0 .587.445 1 .92 1h1.88c.35 0 .7-.308.7-.78 0-.346-.075-.475-.115-.526-.046-.06-.138-.132-.374-.217l-3.012-1.05c-.348-.124-.753-.317-1.055-.703-.31-.394-.434-.887-.434-1.454 0-1.214.947-2.28 2.2-2.28h1.88c1.365 0 2.42 1.147 2.42 2.5a.75.75 0 0 1-1.5 0c0-.588-.445-1-.92-1h-1.88Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20 14.75a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20 10.75c-5.106 0-9.25 4.144-9.25 9.25s4.144 9.25 9.25 9.25 9.25-4.144 9.25-9.25a.75.75 0 0 1 1.5 0c0 5.934-4.816 10.75-10.75 10.75S9.25 25.934 9.25 20 14.066 9.25 20 9.25a.75.75 0 0 1 0 1.5Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.25 12.75A.75.75 0 0 1 24 12h5.5a.75.75 0 0 1 0 1.5H24a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.75 9.25a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V10a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTopUp;